import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRoleFields {
		id?: any;
		selected?: any;
		organisation?: any;
		organisationId?: any;
		concurrencyStamp?: any;
		name?: any;
		normalizedName?: any;
		description?: any;
		changedBy?: any;
		datestamp?: any;
		status?: any;
}

export class RoleFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public selected: IEntityModelField = { name: "selected", displayName: "Selected", fieldType: FieldType.Byte };
	public organisation: IEntityModelField = { name: "organisation", displayName: "Organisation", fieldType: FieldType.String, readOnly: true };
	public organisationId: IEntityModelField = { name: "organisationId", displayName: "Organisation Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public concurrencyStamp: IEntityModelField = { name: "concurrencyStamp", displayName: "Concurrency Stamp", fieldType: FieldType.String, pattern: "NameGeneric" };
	public name: IEntityModelField = { name: "name", displayName: "Name", fieldType: FieldType.String, pattern: "NameGeneric" };
	public normalizedName: IEntityModelField = { name: "normalizedName", displayName: "Normalized Name", fieldType: FieldType.String, pattern: "NameGeneric" };
	public description: IEntityModelField = { name: "description", displayName: "Description", fieldType: FieldType.String, pattern: "NameGeneric" };
	public changedBy: IEntityModelField = { name: "changedBy", displayName: "Changed By", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.selected);
		this.push(this.organisation);
		this.push(this.organisationId);
		this.push(this.concurrencyStamp);
		this.push(this.name);
		this.push(this.normalizedName);
		this.push(this.description);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class RoleDTO implements IEntityModel {
	protected roleName: string = "RoleModel";
	protected roleKeyField: string = "id";
	protected roleDisplayName: string = "Role|Roles";
	protected roleFields = new RoleFields();
	public get name(): string { return this.roleName };
	public get keyField(): string { return this.roleKeyField };
	public get displayName(): string { return this.roleDisplayName };
	public get fields(): RoleFields { return this.roleFields };

	constructor() {};
}
